var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var getMedicationsPerDay = function (medications) {
    var medicationsPerDay = { everyDay: [], 1: [], 2: [], 3: [], 4: [], 5: [], 6: [], 7: [], };
    var allReminders = [];
    medications.forEach(function (m) {
        allReminders = __spreadArray(__spreadArray([], allReminders, true), m.reminders, true);
    });
    allReminders.forEach(function (r) {
        var _a;
        if (((_a = r.days) === null || _a === void 0 ? void 0 : _a.length) === 7) {
            medicationsPerDay.everyDay.push(r);
        }
        else {
            r.days.split('').forEach(function (d) {
                medicationsPerDay[d].push(r);
            });
        }
    });
    return medicationsPerDay;
};
//# sourceMappingURL=monthly-utils.js.map